import { Route } from '@angular/router';
import { authGuard, guestGuard } from './core/auth/auth.guard';

export const appRoutes: Route[] = [
  // Default redirect to login page
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },

  // Auth routes (guest only)
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes),
  },

  // Redirect for backward compatibility
  {
    path: 'login',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },

  // Error pages
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/errors/unauthorized.component').then(c => c.UnauthorizedComponent),
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./features/errors/not-found.component').then(c => c.NotFoundComponent),
  },

  // Protected routes with layout
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./core/layout/app-layout.component').then(c => c.AppLayoutComponent),
    children: [
      // Overview (default landing page)
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./domains/overview/overview.routes').then(m => m.overviewRoutes),
      },

      // Asset Management Domain
      {
        path: 'asset-management',
        loadChildren: () =>
          import('./domains/asset-management/asset.routes').then(m => m.assetRoutes),
      },

      // Scenario Analysis Domain
      {
        path: 'scenarios',
        loadChildren: () =>
          import('./domains/scenario-analysis/scenario.routes').then(m => m.scenarioRoutes),
      },

      // Service Scheduling Domain
      {
        path: 'scheduling',
        loadChildren: () =>
          import('./domains/service-scheduling/scheduling.routes').then(m => m.schedulingRoutes),
      },

      // Program Assignment Domain
      {
        path: 'program-assignment',
        loadChildren: () =>
          import('./domains/program-assignment/program-assignment-routes').then(
            m => m.programAssignmentRoutes
          ),
      },

      // Trade Service Domain
      {
        path: 'trade-service',
        loadChildren: () =>
          import('./domains/trade-service/trade-service-routes').then(m => m.tradeServiceRoutes),
      },

      // Frequency Domain
      {
        path: 'frequency',
        loadChildren: () =>
          import('./domains/frequency/frequency-routes').then(m => m.frequencyRoutes),
      },

      // Spend Analysis Domain
      {
        path: 'action-center',
        loadChildren: () =>
          import('./domains/action-center/action-center.routes').then(m => m.actionCenterRoutes),
      },

      // User Management Domain
      {
        path: 'user-management',
        loadChildren: () =>
          import('./domains/user-management/user-management.routes').then(
            m => m.userManagementRoutes
          ),
      },
      // Provider Management Domain
      {
        path: 'providers',
        loadChildren: () =>
          import('./domains/provider-management/provider.routes').then(m => m.providerRoutes),
      },

      // PM Services Domain
      {
        path: 'pm-services',
        loadChildren: () =>
          import('./domains/pm-services/pm-service-routes').then(m => m.pmServiceRoutes),
      },

      // Location Management Domain
      {
        path: 'locations',
        loadChildren: () =>
          import('./domains/location-management/location.routes').then(m => m.locationRoutes),
      },

      // Opening & Closing Locations Domain
      {
        path: 'opening-closing-locations',
        loadChildren: () =>
          import('./domains/opening-closing-locations/opening-closing-locations.routes').then(
            m => m.openingClosingLocationsRoutes
          ),
      },

      // Reports (cross-cutting feature)
      {
        path: 'reports',
        loadChildren: () => import('./features/reports/reports.routes').then(m => m.reportsRoutes),
      },

      // Settings (admin only)
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then(m => m.settingsRoutes),
      },

      // Demo routes
      {
        path: 'demo',
        children: [
          {
            path: 'server-side-grid',
            loadComponent: () =>
              import('./features/demo/server-side-grid.component').then(
                c => c.ServerSideGridComponent
              ),
          },
        ],
      },
    ],
  },

  // OAuth callback for port 3000 (matches Azure AD config)
  {
    path: 'index.html',
    loadComponent: () =>
      import('./features/auth/oauth-callback.component').then(c => c.OAuthCallbackComponent),
  },

  // Wildcard route - must be last
  {
    path: '**',
    redirectTo: '/not-found',
  },
];
